import { createStore } from 'vuex'

let url = 'https://api.arcticreply.com'
let urlParams = new URLSearchParams(window.location.search)
let mode = 'live'
if (window.location.href.includes('http://localhost:7070')) {
  url = 'http://localhost:3000'
  mode = 'test'
}

let os = navigator.userAgent
if (os.includes('Android') || os.includes('iOS')) os = 'mobile'
else os = 'web'

let language = 'en'
let supportedLanguages = ['en', 'de']
let userLanguage = navigator.language.split('-')[0] || navigator.userLanguage.split('-')[0]
if (supportedLanguages.includes(userLanguage)) language = userLanguage

export default createStore({
  modules: {},

  state() {
    return {
      url,
      language,
      os,
      mode,
      toast: { show: false, message: '' },
      salesMail: '',
      generatedMails: 0,
      campaign: urlParams.get('campaign'),
    }
  },

  mutations: {
    setLanguage(state, language) {
      if (supportedLanguages.includes(language)) state.language = language
      else state.language = 'en'
    },

    setSalesMail(state, mail) {
      state.salesMail = mail
    },

    setToastMessage(state, message) {
      state.toast.show = true
      state.toast.message = message
    },

    clearToastMessage(state) {
      state.toast.show = false
      state.toast.message = ''
    },

    setGeneratedMails(state, generated) {
      state.generatedMails = generated
    },
  },

  actions: {
    /*
      ROUTE /website/mails-generated
    */
    async getMailsGeneratedToday({ state, commit }) {
      if (state.mode === 'test') return

      let url = `${state.url}/website/mails-generated`

      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      })

      const data = await response.json()

      if (data.error) return
      if (data.generated) commit('setGeneratedMails', data.generated)
    },

    async updateMailsGeneratedToday({ state, commit }) {
      let url = `${state.url}/website/mails-generated`

      const response = await fetch(url, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
      })

      const data = await response.json()

      if (data.error) return
      if (data.generated) commit('setGeneratedMails', data.generated)
    },

    /*
      ROUTE /website/generate-email
    */
    async generateEmail({ state, commit }, payload) {
      let url = `${state.url}/website/generate-email`

      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...payload,
        }),
      })

      const data = await response.json()

      if (!response.ok || data.error) return commit('setToastMessage', data.error)

      if (data.email) {
        commit('setSalesMail', data.email)
        return true
      }

      return false
    },

    /*
      ROUTE /events/unsubscribe-newsletter
    */
    async unsubscribeNewsletter({ state, commit }, email) {
      let url = `${state.url}/events/unsubscribe-newsletter?email=${email}`

      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      })

      const data = await response.json()

      if (data.success) return true

      return false
    },
  },

  getters: {
    getSalesMail(state) {
      return state.salesMail
    },

    getToastNotification(state) {
      return state.toast
    },

    getGeneratedMails(state) {
      return state.generatedMails
    },
  },
})
